document.addEventListener('DOMContentLoaded', () => {
  const bundleItems = document.querySelectorAll('.bundle-item');

  /*
  --------------------------------------------------
  PRE-ORDER VARIANTS

  These values must exactly match the Shopify
  color and size option values.
  --------------------------------------------------
  */

  const preorderVariants = [
    'Black / S',
    'Black / M',
    'Black / L',
    'Black / XL'
  ];

  const isPreorderVariant = (color, size) => {
    const variantName = `${color} / ${size}`;
    return preorderVariants.includes(variantName);
  };

  bundleItems.forEach((item) => {
    const colorSelect = item.querySelector('.bundle-color-select');
    const sizeSelect = item.querySelector('.bundle-size-select');
    const statusBox = item.querySelector('.bundle-status');
    const variantInput = item.querySelector('.bundle-variant-id');
    const variantsJson = item.querySelector('.bundle-variants-json');

    if (
      !colorSelect ||
      !sizeSelect ||
      !statusBox ||
      !variantInput ||
      !variantsJson
    ) {
      return;
    }

    let variants = [];

    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (error) {
      console.error('Invalid bundle variant JSON:', error);
      return;
    }

    /*
    --------------------------------------------------
    COLOR CHANGE
    --------------------------------------------------
    */

    colorSelect.addEventListener('change', () => {
      sizeSelect.innerHTML = `
        <option value="">
          Select Size
        </option>
      `;

      variantInput.value = '';
      statusBox.innerHTML = '';

      const selectedColor = colorSelect.value;


      if (!selectedColor) {
        return;
      }

      const filteredVariants = variants.filter((variant) => {
        return variant.option1 === selectedColor;
      });

      const addedSizes = [];

      filteredVariants.forEach((variant) => {
        const size = variant.option2;

        if (!size || addedSizes.includes(size)) {
          return;
        }

        const isPreOrder = isPreorderVariant(
          selectedColor,
          size
        );

        const limitedSizeColors = [
          'Dark Green',
          'Yellow',
          'Orange',
          'Sky Blue',
          'Emerald Green'
        ];

        const isLimitedSize =
          limitedSizeColors.includes(selectedColor) &&
          (size === '3XS' || size === '2XS');

        const isUnavailable =
          !variant.available && !isPreOrder;

        const option = document.createElement('option');

        option.value = size;
        option.dataset.variantId = variant.id;
        option.dataset.preorder = isPreOrder
          ? 'true'
          : 'false';

        if (isPreOrder) {
          option.textContent = `${size} - Pre-order`;
        } else if (isUnavailable) {
          if (isLimitedSize) {
            option.textContent = `${size} - Unavailable for ${selectedColor}`;
          } else {
            option.textContent = `${size} - Out of Stock`;
          }
        } else {
          option.textContent = size;
        }

        option.disabled = isUnavailable;

        sizeSelect.appendChild(option);
        addedSizes.push(size);
      });
    });

    /*
    --------------------------------------------------
    SIZE CHANGE
    --------------------------------------------------
    */

    sizeSelect.addEventListener('change', () => {
      const selectedColor = colorSelect.value;
      const selectedSize = sizeSelect.value;

      const matchedVariant = variants.find((variant) => {
        return (
          variant.option1 === selectedColor &&
          variant.option2 === selectedSize
        );
      });

      if (!matchedVariant) {
        variantInput.value = '';

        statusBox.innerHTML = `
          <span class="bundle-status__error">
            Variant unavailable
          </span>
        `;

        return;
      }

      const isPreOrder = isPreorderVariant(
        selectedColor,
        selectedSize
      );

      if (!matchedVariant.available && !isPreOrder) {
        variantInput.value = '';

        statusBox.innerHTML = `
          <span class="bundle-status__error">
            Out of stock
          </span>
        `;

        return;
      }

      /*
      Allow the selected variant to be submitted
      for both in-stock and pre-order variants.
      */

      variantInput.value = matchedVariant.id;

      if (isPreOrder) {
        let html = `
          <div class="bundle-preorder-note">
            <strong>PRE-ORDER</strong>Note: DISPATCHING FROM 1 AUGUST
          </div>
        `;

        statusBox.innerHTML = html;
      } else {
        let html = `
          <span class="bundle-status__available">
            In stock
          </span>
        `;

        statusBox.innerHTML = html;
      }
    });
  });
});